import React, { forwardRef } from 'react';

import { TextFieldInputProps, TextFieldInputColorProps, TextFieldElement } from './types';
import { TEXT_FIELD_INPUT_QUIET_PROPS, TEXT_FIELD_INPUT_LOUD_PROPS } from './constants';

import BaseTextFieldInput from './BaseTextFieldInput';

const TextFieldInput: React.ForwardRefRenderFunction<TextFieldElement, TextFieldInputProps> = (
  props,
  ref
) => {
  const { variant, ...restProps } = props;

  let textFieldVariantProps: TextFieldInputColorProps;
  switch (true) {
    case variant === 'quiet':
      textFieldVariantProps = TEXT_FIELD_INPUT_QUIET_PROPS;
      break;
    case variant === 'loud':
      textFieldVariantProps = TEXT_FIELD_INPUT_LOUD_PROPS;
      break;
    default:
      textFieldVariantProps = TEXT_FIELD_INPUT_QUIET_PROPS;
      break;
  }

  return <BaseTextFieldInput {...textFieldVariantProps} {...restProps} ref={ref} />;
};

export default forwardRef(TextFieldInput);
